import moment  from 'moment'
import v4 from 'uuid';

const _data = {
    // cid : 1,
    // segid : 1,
    uid : 1,
    status:1
};

function create(values) {
    // values.cid = _data.cid
    // values.segid = _data.segid
    // values.txnid = v4();
    values.dt_create = moment().format('YYYY-MM-DD HH:mm:ss')
    values.dt_update =  moment().format('YYYY-MM-DD HH:mm:ss')
    values.uid_create = _data.uid
    values.uid_update = _data.uid
}

function update(values) {
    // values.cid = _data.cid
    // values.segid = _data.segid
    // values.txnid = v4();
    values.dt_update =  moment().format('YYYY-MM-DD HH:mm:ss')
    values.uid_update = _data.uid
}

const userACL = {
  add: item => _data.push(item),
  atFetch: () => _data,
  atCreate: values => create(values),
  atUpdate: values => update(values)
}

Object.freeze(userACL);
export default userACL;